module.exports = __webpack_public_path__ + "static/img/cace.2c1b80e6.png";